/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {
  LitElement,
  html,
  CSSResultArray,
  TemplateResult,
} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from './nile-list.css';
import NileElement from '../internal/nile-element';

/**
 * Nile list component.
 *
 * @tag nile-list
 *
 */
@customElement('nile-list')
export class NileList extends NileElement {
  /**
   * The styles for nile-list
   * @remarks If you are extending this class you can extend the base styles with super. Eg `return [super(), myCustomStyles]`
   */
  public static get styles(): CSSResultArray {
    return [styles];
  }

  /* #endregion */

  /* #region Methods */

  /**
   * Render method
   * @slot This is a slot test
   */

  handleListItemClick(e: any) {
    const listTextValue = e.target.innerText;
    this.emit('nile-list-click', { value: listTextValue });
  }

  public render(): TemplateResult {
    return html`
      <slot @nile-list-item-click="${this.handleListItemClick}"> </slot>
    `;
  }

  /* #endregion */
}

export default NileList;

declare global {
  interface HTMLElementTagNameMap {
    'nile-list': NileList;
  }
}
